<template>
    <div class="ui grid container" v-show="messageList.length > 0">
        <div class="row">
            <div class="ui negative floating message sixteen wide column" >
                <i class="close icon" @click="clearMessageList"></i>
                <div class="header">
                    Error Message
                </div>
                <ul class="list">
                    <li v-for="msg in messageList" v-html="msg"></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        props: ['message-list'],
        methods: {
            clearMessageList() {
                this.$emit('clearMessageList');
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ErrorMessage.vue?72c40bb2